$(function () {

    function initSwiper(id) {
        const swiper = new Swiper('#' + id, {
            autoplay: false,
            pagination: {
                el: '#' + id + ' .arrow_box .swiper-pagination',
                clickable: true,
            },
        });

        const swiperContainer = $('#' + id).closest('.swiper-1, .swiper-2, .swiper-3'); 
        const productUl = swiperContainer.find('.product-ul');

        productUl.find('p').on('click', function() {
            const index = $(this).index();
            swiper.slideTo(index);
            productUl.find('p').removeClass('active');
            $(this).addClass('active');
        });

        swiper.on('slideChange', function() {
            const currentIndex = swiper.activeIndex;
            productUl.find('p').removeClass('active');
            productUl.find('p').eq(currentIndex).addClass('active');
        });

        return swiper;
    }

    initSwiper('ShopfiyB2B-1');
    initSwiper('ShopfiyB2B-2');
    initSwiper('ShopfiyB2B-3');
})